const i = "알림", o = "중요 알림", t = "알림 닫기", c = {
  notification: i,
  criticalNotification: o,
  close: t
};
export {
  t as close,
  o as criticalNotification,
  c as default,
  i as notification
};
